import {
  Box,
  Divider,
  Flex,
  MediaBox,
  Picture,
  Typography,
} from "@jewlr/storybook/core"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { Text } from "@jewlr/storybook/info"
import { jewlr_t } from "helpers/application"
import { LinkButton } from "jewlr/pages/components"

const SectionTitle = styled(Typography).attrs((props) => ({
  fontSize: 16,
  fontWeight: { tablet: "normal" },
  letterSpacing: { _: "1.5px", tablet: "1px" },
  lineHeight: "2",
  ...props,
}))``

const SectionDivider = styled(Divider).attrs((props) => ({
  bg: "grey.10",
  mb: 2,
  mx: "auto",
  width: "100px",
  ...props,
}))``

const ChainSection = styled(Flex).attrs((props) => ({
  alignItems: { tablet: "center" },
  flexDirection: { _: "column", tablet: "row" },
  ...props,
}))``

const ChainDataContainer = styled(Box).attrs((props) => ({
  bg: "grey.4",
  px: 4,
  py: 5,
  width: { tablet: "110%" },
  ...props,
}))`
  position: relative;
  ${(props) => props.theme.mediaQueries.tablet`
    ${
      props.right &&
      `
      right: 10%;
    `
    }
    ${
      props.left &&
      `
      left: 10%;
    `
    }
    z-index: 2;
  `}
`
const ChainImg = styled(Box).attrs((props) => ({
  flex: { tablet: "1" },
  ...props,
}))`
  position: relative;
  z-index: 1;
  img {
    border: 1px solid #646464;
  }
`
const ChainData = styled(Flex).attrs((props) => ({
  justifyContent: "space-between",
  mb: 1,
  pb: 1,
  ...props,
}))`
  border-bottom: 1px solid ${(props) => props.theme.colors.grey[20]};
  :last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
`
const ChainDataText = styled(Typography).attrs((props) => ({
  fontSize: { tablet: "16px" },
  letterSpacing: { tablet: "1px" },
  light: true,
  ...props,
}))``

const ButtonBlackKeyline = styled(LinkButton)`
  border: solid 1px ${(props) => props.theme.colors.black};
  box-shadow: none;
`

const ChainsInformation = () => (
  <Box my={4}>
    <Box contain px={2} textAlign="center">
      <Text mb={4} mx="auto" width={{ _: "90%", tablet: "50%" }}>
        Our necklaces are designed with chain options that offer the best
        combination of aesthetics and durability.
      </Text>

      <Typography
        fontSize={{ _: "18px", tablet: "16px" }}
        fontWeight={{ tablet: "normal" }}
        letterSpacing="1px"
      >
        WOMEN&apos;S CHAINS
      </Typography>
      <SectionDivider my={2} />
      <MediaBox lessThan="tablet" mb={3}>
        <SectionTitle>STERLING SILVER CABLE</SectionTitle>
        <SectionDivider />
      </MediaBox>
      <ChainSection mb={6}>
        <ChainImg textAlign="left">
          <Picture
            alt="Sterling Silver Cable Chains"
            fallback={require("images/info/chain_information/silver_cable.png")}
            srcSet={[
              {
                height: "767",
                media: "(max-width: 767px)",
                sizes: "100vw",
                srcSet: `${require("images/info/chain_information/silver_cable_mobile.png")} 767w`,
                width: "767",
              },
              {
                height: "340",
                media: "(min-width: 768px)",
                ratio: "1 / 1",
                sizes: "496px",
                srcSet: `
                  ${require("images/info/chain_information/silver_cable.png")} 340w,
                  ${require("images/info/chain_information/silver_cable_2x.png")} 680w,
                `,
                width: "340",
              },
            ]}
          />
        </ChainImg>
        <Box flex={{ tablet: "1" }}>
          <MediaBox greaterThanOrEqual="tablet" mb={3}>
            <SectionTitle>STERLING SILVER CABLE</SectionTitle>
            <SectionDivider />
          </MediaBox>
          <ChainDataContainer right>
            <ChainData>
              <ChainDataText>CHAIN THICKNESS</ChainDataText>
              <ChainDataText>1.25mm</ChainDataText>
            </ChainData>
            <ChainData>
              <ChainDataText>CHAIN LENGTHS</ChainDataText>
              <ChainDataText>
                14&quot;, 16&quot;, 18&quot;, 24&quot;
              </ChainDataText>
            </ChainData>
            <ChainData>
              <ChainDataText>CLASP STYLE</ChainDataText>
              <ChainDataText>SPRING RING</ChainDataText>
            </ChainData>
          </ChainDataContainer>
        </Box>
      </ChainSection>
    </Box>

    <Box bg={{ tablet: "grey.4" }} mb={6} py={4}>
      <Box contain px={{ _: 2, tablet: 0 }} textAlign="center">
        <MediaBox lessThan="tablet" mb={3}>
          <SectionTitle>DIAMOND CUT CABLE</SectionTitle>
          <SectionDivider />
        </MediaBox>
        <ChainSection>
          <ChainImg order={{ tablet: 2 }} textAlign="right">
            <Picture
              alt="Diamond Cut Cable Chains"
              fallback={require("images/info/chain_information/diamond_cut_cable.png")}
              srcSet={[
                {
                  height: "767",
                  media: "(max-width: 767px)",
                  sizes: "100vw",
                  srcSet: `${require("images/info/chain_information/diamond_cut_cable_mobile.png")} 767w`,
                  width: "767",
                },
                {
                  height: "340",
                  media: "(min-width: 768px)",
                  ratio: "1 / 1",
                  sizes: "496px",
                  srcSet: `
                    ${require("images/info/chain_information/diamond_cut_cable.png")} 340w,
                    ${require("images/info/chain_information/diamond_cut_cable_2x.png")} 680w,
                  `,
                  width: "340",
                },
              ]}
            />
          </ChainImg>
          <Box flex={{ tablet: "1" }} order={{ tablet: 1 }}>
            <MediaBox greaterThanOrEqual="tablet" mb={3}>
              <SectionTitle>DIAMOND CUT CABLE</SectionTitle>
              <SectionDivider />
            </MediaBox>
            <ChainDataContainer bg={{ _: "grey.4", tablet: "white" }} left>
              <ChainData>
                <ChainDataText>
                  {jewlr_t("terms.color").toUpperCase()} OPTIONS
                </ChainDataText>
                <ChainDataText>WHITE, YELLOW, ROSE</ChainDataText>
              </ChainData>
              <ChainData>
                <ChainDataText>KARAT OPTIONS</ChainDataText>
                <ChainDataText>10K, 14K</ChainDataText>
              </ChainData>
              <ChainData>
                <ChainDataText>CHAIN THICKNESS</ChainDataText>
                <ChainDataText>1mm</ChainDataText>
              </ChainData>
              <ChainData>
                <ChainDataText>CHAIN LENGTHS</ChainDataText>
                <ChainDataText>14&quot;, 16&quot;, 18&quot;</ChainDataText>
              </ChainData>
              <ChainData>
                <ChainDataText>CLASP STYLE</ChainDataText>
                <ChainDataText>SPRING RING</ChainDataText>
              </ChainData>
            </ChainDataContainer>
          </Box>
        </ChainSection>
      </Box>
    </Box>

    <Box contain mb={6} px={2} textAlign="center">
      <ButtonBlackKeyline
        as={Link}
        data-lc="chains-information"
        display="inline-block"
        to="/necklaces"
      >
        Shop Women&apos;s Necklaces
      </ButtonBlackKeyline>
    </Box>
  </Box>
)

export default ChainsInformation
